import React, { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Search, LayoutGrid, List, X } from 'lucide-react'

interface SearchBarProps {
  onSearch?: (query: string) => void
  listStyle?: 'grid' | 'list'
  onListStyleChange?: (style: string) => void
}

export function SearchBar({ onSearch, listStyle = 'grid', onListStyleChange }: SearchBarProps) {
  const [query, setQuery] = useState('')

  const handleClear = () => {
    setQuery('')
    onSearch?.('')
  }

  return (
    <div className="flex items-center gap-2 px-4 md:px-6 lg:px-8 mt-3">
      <div className="relative flex flex-1 items-center">
        <Search className="absolute w-4 h-4 text-muted-foreground pointer-events-none z-10" style={{ left: '8px', top: '47%', transform: 'translateY(-100%)' }} />
        <Input
          type="text"
          placeholder="Search STASH cards..."
          value={query}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setQuery(e.target.value)
            onSearch?.(e.target.value)
          }}
          className="pl-9 pr-8 h-9 rounded-full bg-muted/50 border-transparent focus:border-[var(--stash-blue)]/30 focus:bg-background text-sm"
          style={{ paddingLeft: '25px' }}
        />
        {query && (
          <button
            onClick={handleClear}
            className="absolute right-3 text-muted-foreground hover:text-foreground transition-colors z-10"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {/* List style toggle */}
      <div className="flex bg-muted rounded-lg p-0.5">
        <button
          onClick={() => onListStyleChange?.('grid')}
          className={`p-1.5 rounded-md transition-all ${
            listStyle === 'grid'
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          aria-label="Grid view"
        >
          <LayoutGrid className="w-4 h-4" />
        </button>
        <button
          onClick={() => onListStyleChange?.('list')}
          className={`p-1.5 rounded-md transition-all ${
            listStyle === 'list'
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
          aria-label="List view"
        >
          <List className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
